import './assets/css/style.css';
import './assets/css/media.css';
const intro = document.querySelector('.introduction');
const navBarLarge = document.querySelector('.navbar-large');
const contactBtn = document.querySelector('.contact-me');
let navItems = navBarLarge.querySelectorAll('.item');
let lpText = document.querySelector('.lp-text');
let projLink = document.querySelector('.projLink');
let menuToogle = document.querySelector('.close-menu')
const html = document.getElementById('html');
const body = document.getElementById('body');
let c = 0

document.addEventListener('click', e => {
    const el = e.target
    console.log(e)
    if(el.classList.contains('fa-language')) {
        ++c
        if(c % 2 == 1) {
            if (intro != null && contactBtn != null && lpText != null && projLink != null) {

                intro.innerHTML = 
                `<p>Olá! Sou <span style="font-size: 48px; font-weight: bold; color: #D9089E; box-shadow: 0px 2px 0px 0px #d9089e;">Marcello Ronald</span></p> 
                <p>Bem vindo ao meu portfolio</p> 
                <p>Dê uma olhada!</p>`
                contactBtn.innerText = `Contate-me`
    
                lpText.innerHTML = `Últimos projetos`
                projLink.innerHTML = `Ver todos...`
            }
            navItems[1].innerHTML = `<li class="item"><span style="color: #D9089E;">&lt;</span><a href="projects.html">projetos</a><span style="color: #D9089E;">&gt;</span></li>`
            navItems[2].innerHTML = `<li class="item"><a href="about.html">sobre</a></li>`
        } else if (c % 2 == 0) {
            if (intro != null && contactBtn != null && lpText != null && projLink != null) {
                intro.innerHTML = 
                `<p>Hello! I'm <span style="font-size: 48px; font-weight: bold; color: #D9089E; box-shadow: 0px 2px 0px 0px #d9089e;">Marcello Ronald</span></p> 
                <p>Welcome to my portfolio</p> 
                <p>Take a look!</p>`
                contactBtn.innerText = `Contact-me`
                lpText.innerHTML = `Last Projects`
                projLink.innerHTML = `See all...`
            }

            navItems[1].innerHTML = `<li class="item"><span style="color: #D9089E;">&lt;</span><a href="projects.html">projects</a><span style="color: #D9089E;">&gt;</span></li>`
            navItems[2].innerHTML = `<li class="item"><a href="about.html">about</a></li>`
        }
    }

})

document.addEventListener('change', e => {
    if(menuToogle.checked === true) {
        document.addEventListener('touchmove', e => {
            e.preventDefault()
        })
    }
    else return
});